module.exports = __webpack_public_path__ + "img/flag_126.99cfb02c.png";